'use client';
import React, { useRef, useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const CTAStrip: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-24 px-6" ref={ref}>
      <div className="max-w-4xl mx-auto">
        <div
          className={`glass-panel teal-glow-box border-[rgba(0,229,204,0.25)] p-12 md:p-16 text-center transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Glow orb */}
          <div
            className="w-32 h-32 rounded-full mx-auto mb-8 flex items-center justify-center"
            style={{ background: 'radial-gradient(circle, rgba(0,229,204,0.2) 0%, transparent 70%)' }}
          >
            <div className="w-16 h-16 rounded-full bg-[rgba(0,229,204,0.15)] flex items-center justify-center">
              <Icon name="BoltIcon" size={32} className="text-teal" variant="solid" />
            </div>
          </div>

          <h2
            className="heading font-black text-white mb-4"
            style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)' }}
          >
            The workbench is clean.
            <br />
            <span className="teal-gradient-text">Every total reconciled.</span>
          </h2>
          <p className="text-[#C0C7D0] text-base max-w-xl mx-auto mb-10 leading-relaxed">
            Join 14,000+ independent garages, multi-bay service centers, and mobile mechanics
            who stopped losing money to handwritten tickets.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a href="#" className="btn-teal px-10 py-4 text-[15px] w-full sm:w-auto text-center">
              Start Free — No Card Required
            </a>
            <a href="#calculator" className="btn-ghost px-8 py-4 text-[14px] w-full sm:w-auto text-center">
              Run My Shop&apos;s Numbers First
            </a>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-[11px] text-[rgba(192,199,208,0.45)] tracking-wide">
            <span className="flex items-center gap-1.5">
              <Icon name="CheckCircleIcon" size={12} className="text-teal" />
              No DMS migration
            </span>
            <span className="flex items-center gap-1.5">
              <Icon name="CheckCircleIcon" size={12} className="text-teal" />
              No credit card
            </span>
            <span className="flex items-center gap-1.5">
              <Icon name="CheckCircleIcon" size={12} className="text-teal" />
              Works from your truck
            </span>
            <span className="flex items-center gap-1.5">
              <Icon name="CheckCircleIcon" size={12} className="text-teal" />
              Live in under 10 minutes
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTAStrip;